import { useState, useEffect } from "react";
import { Box, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const Tabs = () => {

    const [liveTab, setLiveTab] = useState("outline");
    const [recentTab, setRecentTab] = useState("outline");
    const [standsTab, setStandsTab] = useState("outline");

    useEffect(() => {
        switch(window.location.pathname){
            case "/live" :
                setLiveTab("solid");
                setRecentTab("outline");
                setStandsTab("outline");
            break;

            case "/recent/matches" :
                setLiveTab("outline");
                setRecentTab("solid");
                setStandsTab("outline");
            break;

            case "/standings" :
                setLiveTab("outline");
                setRecentTab("outline");
                setStandsTab("solid");
            break;

            default: setLiveTab("solid");
        }
    },[]);

    function switchTabIndicator(){
        setTimeout(
            function(){
                window.location.reload();
            },1);
    }

    return(
        <Box display="flex" justifyContent="space-between" mt="5">
            <Link to="/live">
            <Button colorScheme='blue' variant={liveTab} size="sm" w="6rem">
                Live
            </Button>
            </Link>

            <Link to="/recent/matches" onClick={switchTabIndicator}>
            <Button colorScheme='blue' variant={recentTab} size="sm" w="6rem">
                Recent
            </Button>
            </Link>

            <Link to="/standings" onClick={switchTabIndicator}>
            <Button colorScheme='blue' variant={standsTab} size="sm" w="6rem">
                Standings
            </Button>
            </Link>
        </Box>
    );
}

export default Tabs;